export const calculateAge = (date) => {
  const todaydate = new Date();
  const birthdate = new Date(date);

  return todaydate.getFullYear() - birthdate.getFullYear();
};
